import { StandardEvents } from '@shopify/events';

(() => {
  if (window.YSCart) return;

  const dialog = document.getElementById('ys-cart');
  const page = document.getElementById('ys-cart-page');
  if (!dialog && !page) return;

  const root = window.Shopify?.routes?.root || '/';
  const roots = () => [dialog, page].filter(Boolean);
  const each = (selector, fn) => roots().forEach(r => r.querySelectorAll(selector).forEach(fn));
  const setText = (selector, value) => each(selector, el => { el.textContent = value; });
  const setHTML = (selector, value) => each(selector, el => { el.innerHTML = value; });
  const setHidden = (selector, value) => each(selector, el => { el.hidden = value; });

  /* Datos de producto que imprime snippets/ys-cart.liquid */
  const FALLBACK = {
    retinal: {
      id: 11183503343959,
      title: 'Retinal Shot 0,1% Antienvejecimiento',
      url: '/products/retinal-shot-0-1-concentrado-renovador-antiedad',
      image: '',
      claim: 'Concentrado nocturno de retinal al 0,1 %.',
      tiers: [
        { id: 55032693817687, tubos: 1, price: 2499, available: true },
        { id: 55072071745879, tubos: 2, price: 3999, available: true },
        { id: 55072071778647, tubos: 3, price: 4499, available: true }
      ]
    },
    pdrn: {
      id: 11192506188119,
      title: 'Bálsamo PDRN Medicube',
      url: '/products/barra-pdrn-medicube-5-volufiniline™-1',
      image: '',
      claim: 'Bálsamo en barra con PDRN y 5 % de VOLUFINILINE™.',
      variant: 55072069976407,
      price: 2495,
      available: true
    }
  };

  let DATA = FALLBACK;
  try {
    const node = document.getElementById('ys-cart-data');
    if (node) {
      const parsed = JSON.parse(node.textContent);
      DATA = {
        bundleEnabled: parsed.bundleEnabled,
        retinal: { ...FALLBACK.retinal, ...parsed.retinal },
        pdrn: { ...FALLBACK.pdrn, ...parsed.pdrn }
      };
      if (!DATA.retinal.tiers || !DATA.retinal.tiers.length) DATA.retinal.tiers = FALLBACK.retinal.tiers;
    }
  } catch (_) { DATA = FALLBACK; }

  const TIERS = [...DATA.retinal.tiers].sort((a, b) => a.tubos - b.tubos);
  const MAX_TUBOS = TIERS[TIERS.length - 1].tubos;
  const UNIT = TIERS[0].price;

  let cart, busy = false, readVersion = 0, previousFocus, previousOverflow;

  const escape = value => String(value ?? '').replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: cart?.currency || window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
  const error = message => each('[data-ysc-error]', el => { el.textContent = message || ''; el.hidden = !message; });
  const status = message => setText('[data-ysc-status]', message);

  function setBusy(value) {
    busy = value;
    roots().forEach(r => r.setAttribute('aria-busy', String(value)));
    each('[data-ysc-change],[data-ysc-checkout],[data-ysc-upgrade],[data-ysc-add]', button => { button.disabled = value; });
  }

  async function request(path, options = {}) {
    const response = await fetch(root + path, { credentials: 'same-origin', ...options, headers: { Accept: 'application/json', ...options.headers } });
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'No se ha podido actualizar el carrito. Inténtalo de nuevo.');
    return data;
  }

  const tierOf = variantId => TIERS.find(t => t.id === variantId);

  function itemsHTML(data) {
    return data.items.map(item => {
      const key = escape(item.key);
      const original = item.original_line_price;
      const properties = Object.entries(item.properties || {}).filter(([k, v]) => !k.startsWith('_') && v);
      return `<article class="ysc-item">
        ${item.image ? `<img class="ysc-image" src="${escape(item.image)}" alt="${escape(item.product_title)}" width="88" height="105">` : '<div class="ysc-image"></div>'}
        <div><a class="ysc-item-title" href="${escape(item.url)}">${escape(item.product_title)}</a>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="ysc-variant">${escape(item.variant_title)}</p>` : ''}
        ${item.selling_plan_allocation ? `<p class="ysc-plan">${escape(item.selling_plan_allocation.selling_plan.name)}</p>` : ''}
        ${properties.map(([k, v]) => `<p class="ysc-variant">${escape(k)}: ${escape(v)}</p>`).join('')}
        <div class="ysc-row"><div class="ysc-quantity" aria-label="Cantidad de ${escape(item.product_title)}"><button type="button" data-ysc-change="${key}" data-quantity="${item.quantity - 1}" aria-label="Reducir cantidad de ${escape(item.product_title)}">−</button><span>${item.quantity}</span><button type="button" data-ysc-change="${key}" data-quantity="${item.quantity + 1}" aria-label="Aumentar cantidad de ${escape(item.product_title)}">+</button></div><div class="ysc-price">${original > item.final_line_price ? `<s>${money(original)}</s>` : ''}${money(item.final_line_price)}</div></div>
        ${(item.line_level_discount_allocations || []).map(d => `<p class="ysc-label">${escape(d.discount_application.title)} · −${money(d.amount)}</p>`).join('')}
        <button type="button" class="ysc-remove" data-ysc-change="${key}" data-quantity="0" aria-label="Eliminar ${escape(item.product_title)}">Eliminar</button></div></article>`;
    }).join('');
  }

  /* Barra de progreso de packs: cuenta tubos reales, no líneas. */
  function renderReward(data) {
    const lines = data.items.filter(item => String(item.product_id) === String(DATA.retinal.id) && !item.selling_plan_allocation);
    const tubos = lines.reduce((sum, item) => sum + ((tierOf(item.variant_id)?.tubos ?? 1) * item.quantity), 0);
    const enabled = DATA.bundleEnabled !== false && data.currency === 'EUR';

    setHidden('[data-ysc-reward]', !enabled || !tubos);
    setHidden('[data-ysc-urgency]', !tubos);
    if (!enabled || !tubos) { setHidden('[data-ysc-upgrade]', true); return; }

    const next = TIERS.find(t => t.tubos > tubos);
    const faltan = next ? next.tubos - tubos : 0;
    const ahorro = next ? next.tubos * UNIT - next.price : 0;

    setHTML('[data-ysc-progress-text]', next
      ? `Añade ${faltan} tubo${faltan > 1 ? 's' : ''} más y te llevas el <b>pack de ${next.tubos} por ${money(next.price)}</b> · ahorras ${money(ahorro)}`
      : `<b>Pack de ${MAX_TUBOS} activado</b> · estás aprovechando el máximo ahorro`);

    const percent = Math.min(100, (tubos / MAX_TUBOS) * 100);
    each('[data-ysc-progress]', el => { el.style.width = percent + '%'; });
    each('.ysc-track', el => el.setAttribute('aria-valuenow', String(Math.min(tubos, MAX_TUBOS))));

    setHTML('[data-ysc-milestones]', TIERS.map(t => {
      const done = tubos >= t.tubos;
      const best = t.tubos === MAX_TUBOS;
      return `<span class="ysc-milestone${done ? ' is-done' : ''}${best ? ' is-best' : ''}"><span class="ysc-milestone__n">${t.tubos} tubo${t.tubos > 1 ? 's' : ''}</span><span class="ysc-milestone__p">${money(t.price)}</span></span>`;
    }).join(''));

    /* Subir de pack: solo si hay una única línea de Retinal con 1 unidad. */
    const canUpgrade = next && lines.length === 1 && lines[0].quantity === 1 && tierOf(lines[0].variant_id) && next.available !== false;
    each('[data-ysc-upgrade]', button => {
      button.hidden = !canUpgrade;
      if (!canUpgrade) return;
      button.textContent = `Subir al pack de ${next.tubos} · ${money(next.price)}`;
      button.dataset.key = lines[0].key;
      button.dataset.variant = String(next.id);
    });
  }

  /* Producto recomendado con el 50 % cruzado. */
  function renderCross(data) {
    const hasRetinal = data.items.some(item => String(item.product_id) === String(DATA.retinal.id));
    const hasPdrn = data.items.some(item => String(item.product_id) === String(DATA.pdrn.id));

    let offer = null;
    if (hasRetinal && !hasPdrn && DATA.pdrn.available !== false) {
      offer = { title: DATA.pdrn.title, url: DATA.pdrn.url, image: DATA.pdrn.image, claim: DATA.pdrn.claim, price: DATA.pdrn.price, variant: DATA.pdrn.variant, con: 'tu Retinal Shot' };
    } else if (hasPdrn && !hasRetinal) {
      offer = { title: DATA.retinal.title, url: DATA.retinal.url, image: DATA.retinal.image, claim: DATA.retinal.claim, price: TIERS[0].price, variant: TIERS[0].id, con: 'tu bálsamo PDRN' };
    }

    setHidden('[data-ysc-cross]', !offer);
    if (!offer) return;

    const half = Math.round(offer.price / 2);
    setHTML('[data-ysc-cross]', `
      <p class="ysc-cross__head">Completa tu rutina · −50 %</p>
      <div class="ysc-cross__card">
        ${offer.image ? `<img class="ysc-cross__img" src="${escape(offer.image)}" alt="${escape(offer.title)}" width="68" height="68">` : '<div class="ysc-cross__img"></div>'}
        <div>
          <a class="ysc-cross__title" href="${escape(offer.url)}">${escape(offer.title)}</a>
          <p class="ysc-cross__claim">${escape(offer.claim)}</p>
          <p class="ysc-cross__prices"><span class="ysc-cross__now">${money(half)}</span><span class="ysc-cross__was">${money(offer.price)}</span><span class="ysc-cross__tag">−50 %</span></p>
        </div>
        <button type="button" class="ysc-cross__btn" data-ysc-add="${offer.variant}">Añadir al 50 % con ${escape(offer.con)}</button>
      </div>
      <p class="ysc-cross__note">El descuento se aplica solo en el carrito y en el pago.</p>
    `);
  }

  function render(data) {
    cart = data;
    setText('[data-ysc-count]', data.item_count);
    setText('[data-ysc-count-label]', data.item_count ? `· ${data.item_count} artículo${data.item_count > 1 ? 's' : ''}` : '');
    setHidden('[data-ysc-empty]', data.item_count > 0);
    setHidden('[data-ysc-footer]', !data.item_count);
    setHidden('[data-ysc-panel]', !data.item_count);
    setText('[data-ysc-total]', money(data.total_price));
    setHTML('[data-ysc-items]', itemsHTML(data));
    setHTML('[data-ysc-discounts]', (data.cart_level_discount_applications || []).map(d => `<div><span>${escape(d.title)}</span><span>−${money(d.total_allocated_amount)}</span></div>`).join(''));

    each('[data-ysc-savings]', el => {
      el.hidden = !data.total_discount;
      el.textContent = data.total_discount ? 'Descuentos aplicados: ' + money(data.total_discount) : '';
    });

    renderReward(data);
    renderCross(data);

    document.querySelectorAll('cart-icon').forEach(icon => { if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(data.item_count); });
    setBusy(busy);
  }

  async function refresh() {
    const version = ++readVersion;
    const data = await request('cart.js');
    if (version === readVersion) render(data);
    return data;
  }

  function show() {
    if (!dialog || dialog.open || page) return;
    previousFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    dialog.querySelector('[data-ysc-close]')?.focus();
  }

  async function open() {
    show(); error(''); status('Actualizando tu carrito…');
    setBusy(true);
    try { await refresh(); status(''); } catch (e) { error(e.message); status(''); }
    finally { setBusy(false); }
  }

  async function add(body, sourceButton) {
    if (busy) return;
    setBusy(true); error('');
    if (sourceButton) sourceButton.disabled = true;
    try {
      await request('cart/add.js', body instanceof FormData ? { method: 'POST', body } : { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      show(); status('Producto añadido.');
      await refresh();
    } catch (e) { show(); error(e.message); status(''); }
    finally { setBusy(false); if (sourceButton) sourceButton.disabled = false; }
  }

  async function change(key, quantity) {
    if (busy) return;
    setBusy(true); error(''); status('Actualizando…');
    try {
      ++readVersion;
      render(await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) }));
      status(quantity ? 'Cantidad actualizada.' : 'Producto eliminado.');
    } catch (e) { error(e.message); status(''); try { await refresh(); } catch (_) {} }
    finally { setBusy(false); }
  }

  /* Cambia una línea por otra variante (subir de pack). */
  async function swap(key, variantId) {
    if (busy) return;
    setBusy(true); error(''); status('Actualizando tu pack…');
    try {
      ++readVersion;
      await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
      await request('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) });
      render(await request('cart.js'));
      status('Pack actualizado.');
    } catch (e) { error(e.message); status(''); try { await refresh(); } catch (_) {} }
    finally { setBusy(false); }
  }

  function onClick(event) {
    const upgrade = event.target.closest('[data-ysc-upgrade]');
    if (upgrade && upgrade.dataset.key && upgrade.dataset.variant) { swap(upgrade.dataset.key, upgrade.dataset.variant); return; }

    const addButton = event.target.closest('[data-ysc-add]');
    if (addButton) { add({ items: [{ id: Number(addButton.dataset.yscAdd), quantity: 1 }] }, addButton); return; }

    const button = event.target.closest('[data-ysc-change]');
    if (button) change(button.dataset.yscChange, Number(button.dataset.quantity));
  }

  if (dialog) {
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right) dialog.close();
      }
      if (event.target.closest('[data-ysc-close]')) dialog.close();
      onClick(event);
    });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow || '';
      if (previousFocus?.isConnected) previousFocus.focus();
    });
  }

  if (page) {
    page.addEventListener('click', onClick);
    refresh().catch(() => {});
  }

  document.addEventListener('click', event => {
    if (page) return;
    const button = event.target.closest('a[href], [aria-controls="cart-drawer"], [on\\:click]');
    if (!button || dialog?.contains(button)) return;
    const href = button.getAttribute('href');
    const opensCart = button.getAttribute('aria-controls') === 'cart-drawer' || button.getAttribute('on:click')?.includes('#cart-drawer/open') || (href && new URL(href, location.href).pathname === root + 'cart');
    if (opensCart && !event.ctrlKey && !event.metaKey) { event.preventDefault(); event.stopImmediatePropagation(); open(); }
  }, true);

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('.ypr-info form[action*="/cart/add"]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    add(new FormData(form), event.submitter || form.querySelector('[type="submit"]'));
  }, true);

  document.addEventListener(StandardEvents.cartLinesUpdate, event => {
    if (event.action !== 'add') return;
    if (event.promise) event.promise.then(result => { if (!result?.detail?.didError) open(); }).catch(() => {});
    else open();
  });

  window.YSCart = { open, close: () => dialog?.close(), refresh, add };
})();
